







































































import Chatbot, {
    ChatbotSchemaContent,
    ChatbotSchemaEntry,
    ChatbotStyles,
    ChatbotStylesIcon
} from '@/types/Chatbot.interface'
import ChatbotDemo from '@/components/ChatBotDemo.vue'
import ChatbotStyleEditor from '@/components/ChatbotStyleEditor.vue'
import { FormField, FormMessage } from '@/types/Form.interface'
import FormFields from '@/components/FormFields.vue'
import FormLinks from '@/components/FormLinks.vue'
import FormMessages from '@/components/FormMessages.vue'
import FormStyleImage from '@/components/FormStyleImage.vue'
import Vue from 'vue'
export default Vue.extend({
    components: {
        ChatbotDemo,
        ChatbotStyleEditor,
        FormFields,
        FormLinks,
        FormMessages,
        FormStyleImage
    },
    props: ['id'],
    data: () => ({
        //  A loading spinner for when we are fetching chatbot
        loading: false,
        //  Determines if we are ready to display data
        mounted: false,
        //  Our page template toolbar
        toolbar: {
            title: 'Chatbot',
            help: {
                title: 'Chatbot',
                body: 'Grow your text message subscriber list by starting conversations directly from your website with the MessageDesk Chatbot',
                button: {
                    text: 'Learn More',
                    link: `${process.env.VUE_APP_URL_LEARN}/en/articles/5473493-chabot-overview`
                }
            },
            left: [
                {
                    title: 'Back',
                    icon: 'mdi-chevron-left',
                    tooltip: 'Back',
                    permission: 0,
                    feature: null
                }
            ],
            right: []
        }
    }),
    async mounted() {
        // Don't begin mounting if chatbot is disabled
        if (!this.chatbotEnabled) return this.$router.push('/chatbots')

        //  Check if a form is set in the url params
        const id = this.id

        //  Start loading
        this.loading = true

        //  If there is an id set, load it
        if (id) await this.$store.dispatch('chatbotsViewSelectedChatbotGet', id)

        //  Stop loading
        this.loading = false

        //  We use this mounted variable to track that we have finished setup
        this.mounted = true
    },
    computed: {
        brandingEnabled(): boolean {
            return this.$store.getters.getEnabled('branding')
        },
        chatbotDefaultInputs(): FormField[] {
            return this.$store.getters.chatbotDefaultInputs
        },
        chatbotFields(): ChatbotSchemaContent {
            //  Grab our chatbot
            const chatbot = this.selectedChatbot

            //  If we have no selected chatbot, return null
            if (!chatbot) return null

            //  Grab the schema inputs
            const inputs = chatbot?.schema[1]?.content?.inputs

            //  If no inputs, return null
            if (!inputs) return null

            //  else, return our inputs
            return inputs
        },
        chatbotEnabled(): boolean {
            // return this.$store.getters.getEnabled('chatbot')
            return true
        },
        chatbotPanels(): object[] {
            return [
                {
                    title: 'Step 1: Insert Form Fields',
                    description:
                        'Add all of the fields you want to appear on your Chatbot form',
                    type: 'fields'
                },
                {
                    title: 'Step 2: Chatbot Styling',
                    description: 'Add color and text styling to your form',
                    type: 'styles'
                },
                {
                    title: 'Step 3: Customize Message',
                    description:
                        'Customize the message that is sent to your client upon form submission',
                    type: 'messages'
                },
                {
                    title: 'Step 4: Installation',
                    description: 'Install the Chatbot on your website',
                    type: 'links'
                }
            ]
        },
        chatbotStylesIcon(): ChatbotStylesIcon {
            //  Grab the chatbot
            const chatbot = this.selectedChatbot

            //  If no chatbot, return null
            if (!chatbot) return null

            //  Else, grab the styles
            const styles = chatbot.styles

            //  If no styles, return null
            if (!styles) return null

            //  Else, return the icon from our styles
            return styles.icon
        },
        hasPhoneNumberField(): boolean {
            //  If no selectedChatbot, return false
            if (!this.selectedChatbot) return false

            //  GRab our frields from selectedChatbot
            const fields = this.chatbotFields

            //  If no fields, do nothing
            if (!fields) return false

            //  Check if we have a phone path in here
            const phone = fields.find((input: FormField) => {
                return input.name === 'Default Phone'
            })

            //  The condition is based on whether or not phone exists
            return phone != null
        },
        links(): object[] {
            return [
                {
                    header: {
                        text: 'Embed Chatbot On Website',
                        icon: 'mdi-help-circle',
                        tooltip: true,
                        callback: () => {
                            this.$store.dispatch('dialogOpen', {
                                type: 'MESSAGE',
                                title: 'Help',
                                text: 'Embed the chatbot on your website using this script tag',
                                icon: 'mdi-help-circle',
                                color: 'primary'
                            })
                        }
                    },
                    value: `<script src="${this.scriptLink}"><\/script>`
                }
            ]
        },
        responseMessage(): FormMessage[] {
            return [
                {
                    title: 'Form submission thank you message',
                    helpText:
                        'All contacts recieve this message when they submit the form',
                    attribute: 'response_message',
                    text: this.selectedChatbot.response_message,
                    media: this.selectedChatbot.response_media
                }
            ] as FormMessage[]
        },
        rightWidth(): string {
            //  Our width depends on the current breakpoint
            const bp = this.$vuetify.breakpoint.name

            //  Return based on breakpoint name
            return (
                {
                    lg: '35%',
                    md: '45%',
                    sm: '50%'
                }[bp] || '30%'
            )
        },
        scriptLink(): string {
            //  GRab our key from our chatbot
            const key = this.selectedChatbot.key

            //  Grab our base url
            const baseURL = window.axios.defaults.baseURL

            //  Construct our script link
            return `${baseURL}/chatbot?key=${key}`
        },
        selectedChatbot: {
            get(): Chatbot {
                return this.$store.getters.chatbotsViewSelectedChatbot
            },
            set(val: Chatbot): void {
                this.$store.commit('chatbotsViewSelectedChatbotSet', val)
            }
        }
    },
    methods: {
        popPhoneNumberFieldError(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Error',
                text: "A 'Default Phone' contact field is required",
                icon: 'mdi-alert-circle-outline',
                color: 'primary'
            })
        },
        removeBranding(): void {
            // If they have access to branding, return
            if (this.brandingEnabled) return

            //  Else pop this dialog
            this.$store.dispatch('dialogOpen', {
                type: 'FEATURE',
                paywall_type: 'access',
                metadata: 'branding_enabled'
            })
        },
        removeChatbotIcon(): void {
            //  Remove link from chatbot
            this.selectedChatbot.styles.icon.image = null

            //  Update our chatbot
            this.updateChatbot()
        },
        setChatbotIcon(link: string): void {
            //  Assign link to our icon image
            this.selectedChatbot.styles.icon.image = link

            //  Update our chatbot
            this.updateChatbot()
        },
        submitSchema(chatbotSchema: ChatbotSchemaEntry): void {
            //  Set the schema of our chatbot
            this.selectedChatbot.schema = chatbotSchema

            //  Update and refresh chatbot
            this.updateChatbot()
        },
        submitStyles(chatbotStyles: ChatbotStyles): void {
            //  Set the styles of our chatbot
            this.selectedChatbot.styles = chatbotStyles

            //  Update and refresh chatbot
            this.updateChatbot()
        },
        unsetChatbot(): void {
            //  Set our selected chatbot to null
            this.selectedChatbot = null

            //  Navigate to the chatbots index
            this.$router.push('/chatbots')
        },
        async updateChatbot(): Promise<void> {
            // If the chatbot does not have a default phone field, pop and error and return
            if (!this.hasPhoneNumberField) {
                return this.popPhoneNumberFieldError()
            }

            //  Start loading
            this.loading = true

            //  Send the request
            await this.$store.dispatch('chatbotsPut', this.selectedChatbot)

            //  Stop loading
            this.loading = false
        },
        updateMessage(obj: FormMessage): void {
            //  Chatbot only ever deals with response messages
            this.selectedChatbot.response_message = obj.text
            this.selectedChatbot.response_message_media_id = obj.media?.id

            //  Update and refresh chatbot
            this.updateChatbot()
        }
    },
    watch: {
        id(val: number): void {
            //  Set our chatbot to this new id
            this.$store.dispatch('chatbotsViewSelectedChatbotGet', val)
        },
        selectedChatbot(chatbot: Chatbot): void {
            //  If chatbot is set to null unset everything
            if (!chatbot) return this.unsetChatbot()
        }
    }
})
